// extracted by mini-css-extract-plugin
module.exports = {"Container":"TextArea_Container__rgKDt","Error":"TextArea_Error__2tE-6"};